module.exports = __webpack_public_path__ + "static/media/perspective-man-window.fc4bb665.jpg";